import { GoalStatus } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, Colors, Sizes, Variants } from 'shared/components/ui/chip';

export type GoalStatusChipProps = {
  status: GoalStatus;
};

const labelKeyMap: Record<GoalStatus, string> = {
  [GoalStatus.Archived]: 'general.archived',
  [GoalStatus.Completed]: 'general.completed',
};

const colorMap: Record<GoalStatus, Colors> = {
  [GoalStatus.Archived]: Colors.Default,
  [GoalStatus.Completed]: Colors.Success,
};

export const GoalStatusChip: React.FC<GoalStatusChipProps> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t(labelKeyMap[status])}
      size={Sizes.Small}
      variant={Variants.Filled}
      color={colorMap[status]}
    />
  );
};
